import { useCallback } from 'react';
import useGlobals from './useGlobals';
import { ModalData } from '../Types';
import { setModal } from '../Store/Actions/modalActions';
import { embeddingModelService } from '../Services/embeddingModelService';
import { setListReloadType } from '../Store/Actions/environmentActions';
import { PaginationListType } from '../Types/PaginationParams';

const useEmbeddingModels = () => {
    const { handleNavigate, userSettings, i18n, dispatch, windowWidth, getBreakpoint } = useGlobals();

    const deleteModelfunction = useCallback(
        (identifier: string) => {
            if (!userSettings.isLoggedIn) return;
            embeddingModelService.deleteModel(identifier).then(() => {
                dispatch(setListReloadType(PaginationListType.EmbeddingModels));
            });
        },
        [userSettings.isLoggedIn, dispatch],
    );

    const handleOpenConfirmDialog = useCallback(
        (apiKeyIdentifier: string) => {
            dispatch(
                setModal({
                    state: 'open',
                    title: i18n.translate({ id: 'modelDelete.title', sourceName: 'Models' }),
                    content: i18n.translate({ id: 'modelDelete.text', sourceName: 'Models' }),
                    modalSize: 'small',
                    closeOnAction: true,
                    showCloseButton: false,
                    buttonRightAction: () => deleteModelfunction(apiKeyIdentifier),
                } as ModalData),
            );
        },
        [dispatch, deleteModelfunction, i18n],
    );

    return {
        ModelsActions: {
            handleOpenConfirmDialog,
        },
        handleNavigate,
        i18n,
        userSettings,
        windowWidth,
        getBreakpoint,
    };
};

export default useEmbeddingModels;
